import { useState, useEffect, useRef } from "react";
import { DataGrid } from "@mui/x-data-grid";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import {
  Box,
  Button,
  MenuItem,
  Select,
  FormControl,
  Avatar,
  Menu,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  Typography,
  ListItemIcon,
  ListItemText,
} from "@mui/material";
import SearchBar from "../../components/SearchBar";
import { CiFilter, CiEdit } from "react-icons/ci";
import { Offcanvas } from "react-bootstrap";
import MoreVertIcon from "@mui/icons-material/MoreVert";
import { filterEntities, deleteAppraisalFeedback } from "../../apis/apiService";
import { toast } from "react-toastify";
import { useSelector } from "react-redux";
import Loader from "../../components/common/Loader";
import dayjs from "dayjs";
import Swal from "sweetalert2";
import { FilterSummaryBox } from "../../components/common/FilterSummaryBox";
import { CustomNoRowsOverlay } from "../../components/common/OverlayGrid";
import { MdOutlineFileDownload, MdClose } from "react-icons/md";
import { CiExport } from "react-icons/ci";
import { Tooltip } from "@mui/material";
import { RiDeleteBin5Line } from "react-icons/ri";
import "../../App.css";
// import Button from "@mui/material/Button";
import { AddAppraisalFeedback } from "./AddAppraisalFeedback";
import { FilterAppraisalFeedback } from "./FilterAppraisalFeedback";
import { useLocation } from "react-router-dom";
import { useTheme } from "../../ThemeContext";
import { openInNewTab } from "../../utils/openInNewTab";

const AppraisalFeedback = () => {
  const { isDarkMode } = useTheme();
  // const navigate = useNavigate();

  const [filter, setFilter] = useState("all_feedback");
  const [projects, setProjects] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [loading, setLoading] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [showProject, setShowProject] = useState(false);
  const [isSearching, setIsSearching] = useState(false);
  const [totalRecords, setTotalRecords] = useState(0);
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10,
  });

  // NEW: State to store advanced filter parameters
  const [filterPayload, setFilterPayload] = useState(null);


  const [clearFilter, setClearFilter] = useState(false);
  const [menuAnchorEl, setMenuAnchorEl] = useState(null);
  const [selectedTask, setSelectedTask] = useState(null);
  const [editData, setEditData] = useState(null);
  const [isEdit, setIsEdit] = useState(false);
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [selectedRecord, setSelectedRecord] = useState(null);

  // const isDarkMode = document.body.classList.contains("dark") || document.documentElement.classList.contains("dark");



  /*
  // Debounce for search projects
  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
useEffect(() => {
  const timer = setTimeout(() => {
    setDebouncedSearch(searchTerm.trim());
  }, 500);

  return () => clearTimeout(timer);
}, [searchTerm]);

useEffect(() => {
  if (debouncedSearch) {
    fetchSearchedProjects(debouncedSearch, filter);
  } else {
    fetchProjects(filter);
  }
}, [debouncedSearch, filter]);

*/
  const login_user = useSelector((state) => state.selectOptions?.loginUserName);
  const { role: login_user_role } = login_user || {};
  const UserNameOptions = useSelector(
    (state) => state.selectOptions?.UserNameOptions
  );

  const filterOptions = [
    { label: "All Feedback", value: "all_feedback" },
    { label: "Positive Feedback", value: "positive" },
    { label: "Negative Feedback", value: "negative" },
  ];

  const isFilterChanging = useRef(false);


  /* const handleDelete = async () => {
     if (!selectedTask) {
       toast.error("No feedback selected for deletion");
       setMenuAnchorEl(null);
       return;
     }
 
     const feedbackId =
       selectedTask.appraisal_feedback_id ||
       selectedTask.id ||
       selectedTask.feedback_id;
 
     if (!feedbackId) {
       toast.error("Cannot delete: Feedback ID not found");
       setMenuAnchorEl(null);
       return;
     }
 
     console.log(
       "Attempting to delete feedback with ID:",
       feedbackId,
       "Selected task:",
       selectedTask
     );
 
     Swal.fire({
       title: "Are you sure?",
       text: "You won't be able to revert this!",
       icon: "warning",
       showCancelButton: true,
       confirmButtonColor: "#3085d6",
       cancelButtonColor: "#d33",
       confirmButtonText: "Yes, delete it!",
     }).then(async (result) => {
       if (result.isConfirmed) {
         try {
           setLoading(true);
           const response = await deleteAppraisalFeedback(feedbackId);
           console.log("🗑️ Delete response:", response);
 
           if (response && response.status) {
             // FIXED: Immediately remove the deleted record from the table
             setProjects((prevProjects) =>
               prevProjects.filter(
                 (project) =>
                   (project.appraisal_feedback_id ||
                     project.id ||
                     project.feedback_id) !== feedbackId
               )
             );
 
             // Update total records count
             setTotalRecords((prev) => prev - 1);
             toast.success("Appraisal Feedback deleted successfully!");
 
             // FIXED: Also refetch the data to ensure sync with server
             fetchProjects().catch(console.error);
           } else {
             toast.error(response?.message || "Delete failed");
           }
         } catch (error) {
           console.error("❌ Delete error:", error);
           toast.error(error.message || "Failed to delete feedback");
         } finally {
           setLoading(false);
         }
       }
       setMenuAnchorEl(null);
     });
   };
 */

  /*
     const handleDelete = async () => {
    if (!selectedTask) {
      toast.error("No feedback selected for deletion");
      setMenuAnchorEl(null); // Close menu
      return;
    }
  
    const feedbackId =
      selectedTask.appraisal_feedback_id ||
      selectedTask.id ||
      selectedTask.feedback_id;
  
    if (!feedbackId) {
      toast.error("Cannot delete: Feedback ID not found");
      setMenuAnchorEl(null); // Close menu
      return;
    }
  
    console.log(
      "Attempting to delete feedback with ID:",
      feedbackId,
      "Selected task:",
      selectedTask
    );
  
    // CLOSE THE MENU FIRST
    setMenuAnchorEl(null);
  
    // THEN show confirmation popup
    Swal.fire({
      title: "Are you sure?",
      text: "You won't be able to revert this!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, delete it!",
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          setLoading(true);
          const response = await deleteAppraisalFeedback(feedbackId);
          console.log(" Delete response:", response);
  
          if (response && response.status) {
            // Remove the deleted record from the table
            setProjects((prevProjects) =>
              prevProjects.filter(
                (project) =>
                  (project.appraisal_feedback_id ||
                    project.id ||
                    project.feedback_id) !== feedbackId
              )
            );
  
            // Update total records count
            setTotalRecords((prev) => prev - 1);
            toast.success("Appraisal Feedback deleted successfully!");
  
            // Refetch the data to ensure sync with server
            fetchProjects().catch(console.error);
          } else {
            toast.error(response?.message || "Delete failed");
          }
        } catch (error) {
          console.error(" Delete error:", error);
          toast.error(error.message || "Failed to delete feedback");
        } finally {
          setLoading(false);
        }
      }
      // Menu is already closed, so no need to close it again
    });
  };
  */

  const handleDelete = async () => {
    if (!selectedTask) {
      toast.error("No feedback selected for deletion");
      setMenuAnchorEl(null);
      return;
    }

    const feedbackId =
      selectedTask.appraisal_feedback_id ||
      selectedTask.id ||
      selectedTask.feedback_id;

    if (!feedbackId) {
      toast.error("Cannot delete: Feedback ID not found");
      setMenuAnchorEl(null);
      return;
    }

    setMenuAnchorEl(null);

    const result = await Swal.fire({
      title: `Confirm Deletion`,
      html: `Are you sure you want to delete this appraisal feedback?`,
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Yes, Delete it!",
      showCloseButton: true,
      cancelButtonText: "Cancel",
      customClass: {
        popup: "animate__animated animate__fadeInLeft animate__faster custom-swal-popup",
        title: "custom-swal-title",
        htmlContainer: "custom-swal-html",
        icon: "custom-swal-icon",
        confirmButton: "swal-confirm-btn",
        cancelButton: "swal-cancel-btn",
      },
      showClass: {
        popup: "animate__animated animate__fadeInLeft ",
      },
      hideClass: {
        popup: "animate__animated animate__fadeOutRight",
      },
    });

    if (result.isConfirmed) {
      try {
        setLoading(true);

        const response = await deleteAppraisalFeedback(feedbackId);

        if (response && response.status) {
          clearGlobalSearch(); // 🔥 CLEAR SEARCH

          setProjects((prevProjects) =>
            prevProjects.filter(
              (project) =>
                (project.appraisal_feedback_id ||
                  project.id ||
                  project.feedback_id) !== feedbackId
            )
          );

          setTotalRecords((prev) => prev - 1);

          Swal.fire({
            title: "Deleted!",
            text: response.message || "Appraisal Feedback deleted successfully!",
            icon: "success",
            confirmButtonText: "OK",
            customClass: {
              popup: "custom-swal-popup",
              confirmButton: "swal-confirm-btn",
              title: "custom-swal-title",
              text: "custom-swal-html",
              icon: "custom-swal-icon",
            },
          });

          fetchProjects();
        } else {
          toast.error(response?.message || "Delete failed");
        }
      } catch (error) {
        toast.error(error.message || "Failed to delete feedback");
      } finally {
        setLoading(false);
      }
    }
  };

  /*
    const handleEdit = () => {
      if (!selectedTask) {
        toast.error("No feedback selected for editing");
        return;
      }
  
  
      setEditData(selectedTask);
      setIsEdit(true);
      setShowProject(true);
      setMenuAnchorEl(null);
    };
  
  */

  const handleEdit = () => {
    if (!selectedTask) {
      toast.error("No feedback selected for editing");
      return;
    }

    clearGlobalSearch(); // 🔥 CLEAR SEARCH

    setEditData(selectedTask);
    setIsEdit(true);
    setShowProject(true);
    setMenuAnchorEl(null);
  };


  useEffect(() => {
    sessionStorage.removeItem("appraisalFilter")

  }, [])

  useEffect(() => {
    // console.log("project_length :", projects.length)
  }, [projects])



  const handleMenuOpen = (event, row) => {
    event.stopPropagation();
    setMenuAnchorEl(event.currentTarget);
    setSelectedTask(row);
  };

  const handleView = () => {
    setSelectedRecord(selectedTask);
    setShowDetailModal(true);
    setMenuAnchorEl(null);
  };

  // FIXED: Action column - first column
  const actionColumn = {
    field: "actions",
    headerName: "Actions",
    width: 100,
    sortable: false,
    filterable: false,
    renderCell: (params) => (
      <Box display="flex" alignItems="center">
        <IconButton onClick={(event) => handleMenuOpen(event, params.row)}>
          <MoreVertIcon />
        </IconButton>
      </Box>
    ),
  };


  const baseProjectColumns = [

    {
      field: "appraisal_feedback_id",
      headerName: "Appraisal ID",
      width: 120,
      renderCell: (params) => {
        const id =
          params.value ||
          params.row.feedback_id ||
          params.row.id ||
          "";
        return <strong>{id}</strong>;
      },
    },
    {
      field: "user_name",
      headerName: "User Name",
      sortable: true,
      width: 150,
      renderCell: (params) => params.value || "",
    },
    {
      field: "department_name",
      headerName: "Department",
      sortable: true,
      width: 150,
      renderCell: (params) => params.value || "",
    },
    {
      field: "project_name",
      headerName: "Project Name",
      sortable: true,
      width: 200,
      renderCell: (params) => params.value || "",
    },
    {
      field: "feedback_type",
      headerName: "Feedback Type",
      sortable: true,
      width: 150,
      renderCell: (params) => {
        const type = params.value;
        const color =
          type === "positive" || type === "POSITIVE" ? "green" : "red";
        return (
          <span
            style={{
              color: color,
              fontWeight: "bold",
              textTransform: "uppercase",
            }}
          >
            {type ? type.toUpperCase() : ""}
          </span>
        );
      },
    },
    {
      field: "date_of_incident",
      headerName: "Date of Incident",
      width: 150,
      renderCell: (params) =>
        params.value ? dayjs(params.value).format("DD/MM/YYYY") : "",
    },
    {
      field: "comments",
      headerName: "Comments",
      sortable: true,
      width: 200,
      renderCell: (params) => {
        const textContent = params.value
          ? params.value
            .replace(/<\/p>|<\/div>|<\/li>|<br\s*\/?>/gi, "\n")
            .replace(/<[^>]*>/g, "")
            .trim()
          : "";

        return (
          <Tooltip
            title={<div style={{ whiteSpace: "pre-wrap" }}>{textContent}</div>}
            arrow
            placement="top"
            disableHoverListener={!textContent}
          >
            <div
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                maxHeight: "100%",
                overflow: "hidden",
                cursor: "pointer",
              }}
            >
              {textContent.length > 50
                ? textContent.substring(0, 50) + "..."
                : textContent}
            </div>
          </Tooltip>
        );
      },
    },

    {
      field: "remarks",
      headerName: "Remarks",
      width: 150,
      renderCell: (params) => {
        const textContent = params.value ? params.value.trim() : "";

        return (
          <Tooltip
            title={<div style={{ whiteSpace: "pre-wrap" }}>{textContent}</div>}
            arrow
            placement="bottom"
            disableHoverListener={!textContent}
          >
            <div
              style={{
                whiteSpace: "normal",
                wordWrap: "break-word",
                maxHeight: "100%",
                overflow: "hidden",
                cursor: "pointer",
              }}
            >
              {textContent.length > 35
                ? textContent.substring(0, 35) + "..."
                : textContent}
            </div>
          </Tooltip>
        );
      },
    },

    // Img Evidence place here...new
    {
      field: "image_evidence",
      headerName: "Image Evidence",
      width: 180,
      sortable: false,
      renderCell: (params) => {
        let evidence = params.row.image_evidence;

        if (!evidence) {
          return (
            <div className="d-flex justify-content-center align-items-center h-100">
              <span className="text-muted small"></span>
            </div>
          );
        }

        // Normalize to array of clean URLs
        let imageUrls = [];

        if (Array.isArray(evidence)) {
          imageUrls = evidence
            .map(item => {
              if (!item) return null;
              let url =
                item.url ||
                item.path ||
                (typeof item === "string" ? item : null);
              if (!url) return null;
              url = url.replace(/\/storage\/\/storage\//g, "/storage/");
              return url.trim();
            })
            .filter(Boolean);
        } else if (typeof evidence === "string" && evidence.trim()) {
          let url = evidence.trim();
          url = url.replace(/\/storage\/\/storage\//g, "/storage/");
          imageUrls = [url];
        }

        if (imageUrls.length === 0) {
          return (
            <div className="d-flex justify-content-center align-items-center h-100">
              <span className="text-muted small"></span>
            </div>
          );
        }

        const BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/api\/v2\/?$/, "");

        imageUrls = imageUrls.map(url => {
          if (url.startsWith("http://") || url.startsWith("https://")) return url;
          return `${BASE_URL}${url.startsWith("/") ? "" : "/"}${url}`;
        });

        // Function to open image preview modal
        const openImagePreview = () => {
          // Create modal container
          const modalContainer = document.createElement("div");
          modalContainer.style.cssText = `
        position: fixed;
        top: 0;
        left: 0;
        width: 100%;
        height: 100%;
        background: rgba(0, 0, 0, 0.8);
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        z-index: 9999;
        padding: 20px;
      `;

          // Create modal content
          const modalContent = document.createElement("div");
          modalContent.style.cssText = `
        background: white;
        border-radius: 8px;
        padding: 20px;
        max-width: 90%;
        max-height: 90%;
        overflow-y: auto;
        position: relative;
      `;

          // Create header with title and close button
          const header = document.createElement("div");
          header.style.cssText = `
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin-bottom: 20px;
        padding-bottom: 10px;
        border-bottom: 1px solid #eee;
      `;

          const title = document.createElement("p");
          title.style.color = document.body.classList.contains("dark") ? "#fff" : "#000";

          // Fix title format with parentheses
          if (imageUrls.length === 1) {
            title.textContent = `Image Evidence (1 image)`;
          } else if (imageUrls.length > 1) {
            title.textContent = `Image Evidence (${imageUrls.length} images)`;
          } else {
            title.textContent = `Image Evidence (0 images)`;
          }

          title.style.margin = "0";
          title.style.fontWeight = "500";

          const closeBtn = document.createElement("button");
          closeBtn.textContent = "✕";
          closeBtn.style.cssText = `
        background: none;
        border: none;
        font-size: 20px;
        cursor: pointer;
        color: #666;
        padding: 0 5px;
      `;
          // Fix removeChild error
          closeBtn.onclick = () => {
            if (modalContainer && modalContainer.parentNode) {
              document.body.removeChild(modalContainer);
            }
          };

          header.appendChild(title);
          header.appendChild(closeBtn);

          // Create images container
          const imagesGrid = document.createElement("div");

          // Different grid layouts based on image count
          if (imageUrls.length === 1) {
            // Single image - fixed size container
            imagesGrid.style.cssText = `
          display: flex;
          justify-content: center;
          align-items: center;
          margin-bottom: 20px;
          width: 100%;
        `;
          } else if (imageUrls.length === 2) {
            // Two images - side by side
            imagesGrid.style.cssText = `
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 20px;
        `;
          } else if (imageUrls.length === 3) {
            // Three images - 2 on top, 1 on bottom centered
            imagesGrid.style.cssText = `
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 20px;
        `;
          } else if (imageUrls.length === 4) {
            // Four images - 2x2 grid
            imagesGrid.style.cssText = `
          display: grid;
          grid-template-columns: 1fr 1fr;
          gap: 15px;
          margin-bottom: 20px;
        `;
          } else if (imageUrls.length >= 5) {
            // Five+ images - 3 on top, then 2 per row
            imagesGrid.style.cssText = `
          display: grid;
          grid-template-columns: repeat(3, 1fr);
          gap: 15px;
          margin-bottom: 20px;
        `;
          }

          // Add all images to grid
          imageUrls.forEach((url, index) => {
            if (imageUrls.length === 1) {
              // Single image - fixed size container
              const singleImageWrapper = document.createElement("div");
              singleImageWrapper.style.cssText = `
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 5px;
            background: #f9f9f9;
            cursor: pointer;
            transition: transform 0.2s;
            width: 300px;
            margin: 0 auto;
          `;
              singleImageWrapper.onmouseenter = () => singleImageWrapper.style.transform = "scale(1.02)";
              singleImageWrapper.onmouseleave = () => singleImageWrapper.style.transform = "scale(1)";

              const img = document.createElement("img");
              img.src = url;
              img.style.cssText = `
            width: 100%;
            height: 200px;
            object-fit: cover;
            border-radius: 3px;
          `;
              img.onclick = () => openInNewTab(url);

              const imgLabel = document.createElement("div");
              imgLabel.textContent = `Image 1`;
              imgLabel.style.cssText = `
            text-align: center;
            font-size: 12px;
            margin-top: 5px;
            color: #666;
          `;

              singleImageWrapper.appendChild(img);
              singleImageWrapper.appendChild(imgLabel);
              imagesGrid.appendChild(singleImageWrapper);
            } else {
              // Multiple images layout
              const imgContainer = document.createElement("div");
              imgContainer.style.cssText = `
            border: 1px solid #ddd;
            border-radius: 4px;
            padding: 5px;
            background: #f9f9f9;
            cursor: pointer;
            transition: transform 0.2s;
          `;

              // For 3 images layout, make the third image span both columns
              if (imageUrls.length === 3 && index === 2) {
                imgContainer.style.gridColumn = "span 2";
                imgContainer.style.width = "50%";
                imgContainer.style.margin = "0 auto";
              }

              imgContainer.onmouseenter = () => imgContainer.style.transform = "scale(1.05)";
              imgContainer.onmouseleave = () => imgContainer.style.transform = "scale(1)";

              const img = document.createElement("img");
              img.src = url;
              img.style.cssText = `
            width: 100%;
            height: 120px;
            object-fit: cover;
            border-radius: 3px;
          `;
              img.onclick = () => openInNewTab(url);

              const imgLabel = document.createElement("div");
              imgLabel.textContent = `Image ${index + 1}`;
              imgLabel.style.cssText = `
            text-align: center;
            font-size: 12px;
            margin-top: 5px;
            color: #666;
          `;

              imgContainer.appendChild(img);
              imgContainer.appendChild(imgLabel);
              imagesGrid.appendChild(imgContainer);
            }
          });

          // Create download button
          const downloadBtn = document.createElement("button");

          // Set button text based on single/multiple images
          if (imageUrls.length === 1) {
            downloadBtn.textContent = `Download Image`;
          } else {
            downloadBtn.textContent = `Download All as ZIP (${imageUrls.length} images)`;
          }

          downloadBtn.style.cssText = `
        background: #04a189;
        color: white;
        border: none;
        padding: 10px 20px;
        border-radius: 4px;
        cursor: pointer;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        align-items: center;
        gap: 8px;
        margin: 0 auto;
        transition: background 0.3s;
        width: auto;
        min-width: 200px;
        justify-content: center;
      `;
          downloadBtn.onmouseenter = () => downloadBtn.style.background = "#038a74";
          downloadBtn.onmouseleave = () => downloadBtn.style.background = "#04a189";

          // Fixed download function - removed gray button color
          // downloadBtn.onclick = async () => {
          //   try {
          //     downloadBtn.disabled = true;
          //     downloadBtn.style.background = "#04a189"; 
          //     downloadBtn.textContent = imageUrls.length === 1 ? "Download Image" : `Download All as ZIP (${imageUrls.length} images)`;

          //     if (imageUrls.length === 1) {
          //       // Single image - download directly
          //       const url = imageUrls[0];
          //       const filename = url.split("/").pop() || "evidence.png";
          //       const link = document.createElement("a");
          //       link.href = url;
          //       link.download = filename;
          //       document.body.appendChild(link);
          //       link.click();
          //       document.body.removeChild(link);

          //       toast.success("Image downloaded successfully!");

          //       setTimeout(() => {
          //         if (modalContainer && modalContainer.parentNode) {
          //           document.body.removeChild(modalContainer);
          //         }
          //       }, 1500);
          //     } else {
          //       // Multiple images - create ZIP
          //       const zip = new JSZip();
          //       const folder = zip.folder("image_evidence");

          //       // Show progress toast only
          //       const progressToast = toast.loading(`Downloading 0/${imageUrls.length}...`);

          //       for (let i = 0; i < imageUrls.length; i++) {
          //         const url = imageUrls[i];
          //         try {
          //           const response = await fetch(url, { mode: "cors" });

          //           if (!response.ok) {
          //             throw new Error(`Failed to fetch image ${i + 1}`);
          //           }

          //           const blob = await response.blob();
          //           const filename = url.split("/").pop() || `evidence_${i + 1}.png`;
          //           folder.file(filename, blob);

          //           // Update progress in toast only
          //           toast.update(progressToast, {
          //             render: `Downloading ${i + 1}/${imageUrls.length}...`,
          //             isLoading: true
          //           });
          //         } catch (error) {
          //           console.error(`Error fetching image ${i + 1}:`, error);
          //         }
          //       }

          //       // Generate and download ZIP
          //       toast.update(progressToast, {
          //         render: "Creating ZIP file...",
          //         isLoading: true
          //       });

          //       const zipBlob = await zip.generateAsync({ type: "blob" });
          //       const zipFilename = `image_evidence_${params.row.appraisal_feedback_id || params.row.user_name || Date.now()}.zip`;

          //       saveAs(zipBlob, zipFilename);

          //       // Close loading toast and show success
          //       toast.dismiss(progressToast);
          //       toast.success(`${imageUrls.length} images downloaded as ZIP successfully!`);

          //       setTimeout(() => {
          //         if (modalContainer && modalContainer.parentNode) {
          //           document.body.removeChild(modalContainer);
          //         }
          //       }, 1500);
          //     }
          //   } catch (error) {
          //     console.error("Download failed:", error);
          //     downloadBtn.disabled = false;
          //     downloadBtn.style.background = "#04a189";
          //     downloadBtn.style.opacity = "1";
          //     toast.error("Download failed");

          //     // Fallback: download individually
          //     imageUrls.forEach((url, index) => {
          //       setTimeout(() => {
          //         const link = document.createElement("a");
          //         link.href = url;
          //         link.download = url.split("/").pop() || `evidence_${index + 1}.png`;
          //         document.body.appendChild(link);
          //         link.click();
          //         document.body.removeChild(link);
          //       }, index * 300);
          //     });

          //     setTimeout(() => {
          //       if (modalContainer && modalContainer.parentNode) {
          //         document.body.removeChild(modalContainer);
          //       }
          //     }, 2000);
          //   }
          // };

          downloadBtn.onclick = async () => {
            try {
              downloadBtn.disabled = true;
              downloadBtn.style.background = "#04a189";

              const userName =
                (params.row.user_name || "User")
                  .toString()
                  .trim()
                  .replace(/\s+/g, "_");

              if (imageUrls.length === 1) {

                // SINGLE IMAGE DOWNLOAD
                const url = imageUrls[0];

                const extension = url.split(".").pop().split("?")[0] || "png";
                const filename = `${userName}.${extension}`;

                const link = document.createElement("a");
                link.href = url;
                link.download = filename;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);

                toast.success("Image downloaded successfully!");

                setTimeout(() => {
                  if (modalContainer && modalContainer.parentNode) {
                    document.body.removeChild(modalContainer);
                  }
                }, 1500);

              } else {

                // MULTIPLE IMAGES → ZIP DOWNLOAD
                const zip = new JSZip();
                const folder = zip.folder(userName);

                const progressToast = toast.loading(`Downloading 0/${imageUrls.length}...`);

                for (let i = 0; i < imageUrls.length; i++) {
                  const url = imageUrls[i];

                  try {
                    const response = await fetch(url, { mode: "cors" });

                    if (!response.ok) {
                      throw new Error(`Failed to fetch image ${i + 1}`);
                    }

                    const blob = await response.blob();

                    const extension = url.split(".").pop().split("?")[0] || "png";
                    const filename = `${userName}_${i + 1}.${extension}`;

                    folder.file(filename, blob);

                    toast.update(progressToast, {
                      render: `Downloading ${i + 1}/${imageUrls.length}...`,
                      isLoading: true,
                    });

                  } catch (error) {
                    console.error(`Error fetching image ${i + 1}:`, error);
                  }
                }

                toast.update(progressToast, {
                  render: "Creating ZIP file...",
                  isLoading: true,
                });

                const zipBlob = await zip.generateAsync({ type: "blob" });

                const zipFilename = `${userName}.zip`;

                saveAs(zipBlob, zipFilename);

                toast.dismiss(progressToast);
                toast.success(`${imageUrls.length} images downloaded as ZIP successfully!`);

                setTimeout(() => {
                  if (modalContainer && modalContainer.parentNode) {
                    document.body.removeChild(modalContainer);
                  }
                }, 1500);
              }

            } catch (error) {
              console.error("Download failed:", error);
              downloadBtn.disabled = false;
              downloadBtn.style.background = "#04a189";
              toast.error("Download failed");
            }
          };


          // Assemble modal
          modalContent.appendChild(header);
          modalContent.appendChild(imagesGrid);
          modalContent.appendChild(downloadBtn);
          modalContainer.appendChild(modalContent);

          // Close modal on background click
          modalContainer.onclick = (e) => {
            if (e.target === modalContainer && modalContainer.parentNode) {
              document.body.removeChild(modalContainer);
            }
          };

          // Add escape key listener
          const handleEscape = (e) => {
            if (e.key === 'Escape' && modalContainer && modalContainer.parentNode) {
              document.body.removeChild(modalContainer);
              document.removeEventListener('keydown', handleEscape);
            }
          };

          document.addEventListener('keydown', handleEscape);
          document.body.appendChild(modalContainer);
        };

        return (
          <div
            className="d-flex align-items-center justify-content-center"
            style={{ width: "100%" }}
          >
            {/* Just the download icon - no count text */}
            <div
              className="position-relative download-cell-btn"
              title={
                imageUrls.length > 1
                  ? `Click to view and download ${imageUrls.length} images`
                  : "Click to download image"
              }
              onClick={(e) => {
                e.stopPropagation();
                openImagePreview();
              }}
            >
              {/* Download icon */}
              <MdOutlineFileDownload size={26} color="#868484" />
            </div>
          </div>
        );
      },
    },
    {
      field: "created_at",
      headerName: "Added At",
      sortable: true,
      width: 150,
      renderCell: (params) => {
        const createdAt = params.value || params.row.added_at;
        return createdAt ? dayjs(createdAt).format("DD-MM-YYYY") : "";
      },
    },

    // NEW: Added By column
    {
      field: "added_by_name",
      headerName: "Added By",
      width: 150,
      renderCell: (params) => {
        // If backend doesn't provide this, we can show a placeholder or get from user data
        if (params.value) return params.value;

        // Try to find user name from UserNameOptions based on added_by ID
        if (params.row.added_by && UserNameOptions) {
          const user = UserNameOptions.find(
            (u) => u.user_id === params.row.added_by
          );
          return user?.name || `${params.row.added_by}`;
        }
        return "";
      },
    },

    // {
    //   field: "updated_at",
    //   headerName: "Updated At",
    //   sortable: true,
    //   width: 150,
    //   renderCell: (params) => {
    //     const updatedAt = params.value;
    //     return updatedAt ? dayjs(updatedAt).format("DD-MM-YYYY") : "";
    //   },
    // },

    // // NEW: Updated By column
    // {
    //   field: "updated_by_name",
    //   headerName: "Updated By",
    //   width: 150,
    //   renderCell: (params) => {
    //     if (params.value) return params.value;

    //     // Try to find user name from UserNameOptions based on updated_by ID
    //     if (params.row.updated_by && UserNameOptions) {
    //       const user = UserNameOptions.find(
    //         (u) => u.user_id === params.row.updated_by
    //       );
    //       return user?.name || `${params.row.updated_by}`;
    //     }
    //     return params.row.added_by_name || "";
    //   },
    // },
    {
      field: "updated_at",
      headerName: "Updated At",
      sortable: true,
      width: 150,
      renderCell: (params) => {
        // Check both params.value and params.row.updated_at
        const updatedAt = params.value || params.row.updated_at;
        return updatedAt ? dayjs(updatedAt).format("DD-MM-YYYY") : "";
      },
    },

    {
      field: "updated_by_name",
      headerName: "Updated By",
      width: 150,
      renderCell: (params) => {
        // Check multiple possible sources for the data
        if (params.value) return params.value;
        if (params.row.updated_by_name) return params.row.updated_by_name;
        if (params.row.updated_by) {
          // Try to find user name from UserNameOptions
          if (UserNameOptions) {
            const user = UserNameOptions.find(
              (u) => u.user_id === params.row.updated_by
            );
            return user?.name || params.row.updated_by;
          }
          return params.row.updated_by;
        }
        return "";
      },
    },
  ];

  // Combine columns - action column first if user has permission
  const projectColumns =
    login_user_role === "ADMIN" || login_user_role === "MANAGER"
      ? [actionColumn, ...baseProjectColumns]
      : baseProjectColumns;
  /*
    const fetchSearchedProjects = async (searchQuery) => {
      setLoading(true);
      setIsSearching(true);
      // Reset advanced filter state when searching
      setFilterPayload(null);
      setClearFilter(false);
      sessionStorage.removeItem("appraisalFilter");
      
      try {
  
        // 💖 IMPORTANT: Add feedback_type if selected
        const params = {
        search: searchQuery,
        feedback_type: filter,
      };
  
        const response = await fetchAllEntities(
          `appraisalFeedback/getAppraisalFeedbacks?search=${encodeURIComponent(
            searchQuery
          )}`
        );
  
            // 💖 IMPORTANT: Add feedback_type if selected
      if (filter && filter !== "all_feedback") {
        params.feedback_type = filter;
      }
  
  
        let feedbackData = [];
        if (response.status && response.data) {
          if (response.data.data && Array.isArray(response.data.data)) {
            feedbackData = response.data.data;
          } else if (Array.isArray(response.data)) {
            feedbackData = response.data;
          }
        }
  
        const processedData = feedbackData.map((feedback, index) => ({
          ...feedback,
          id:
            feedback.appraisal_feedback_id ||
            feedback.feedback_id ||
            feedback.id ||
            index,
        }));
  
        setProjects(processedData);
         console.log("appraisal_feedback", processedData);
        setTotalRecords(feedbackData.length);
      } catch (error) {
        toast.error(error.message || "Search failed");
        setProjects([]);
        setTotalRecords(0);
      } finally {
        setLoading(false);
        setIsSearching(false);
      }
    };
  */

  const fetchSearchedProjects = async (searchQuery) => {
    setLoading(true);
    setIsSearching(true);

    try {
      const filteredData = sessionStorage.getItem("appraisalFilter")
      const parsedFilteredData = filteredData ? JSON.parse(filteredData) : {};
      const params = {
        search: searchQuery,
        feedback_type: filter === "all_feedback" ? null : filter,
        ...parsedFilteredData
      };

      const response = await filterEntities(
        "appraisalFeedback/getAppraisalFeedbacks",
        params
      );

      let feedbackData = [];

      if (response.status && response.data) {
        if (response.data.data && Array.isArray(response.data.data)) {
          feedbackData = response.data.data;
        } else if (Array.isArray(response.data)) {
          feedbackData = response.data;
        }
      }

      const processedData = feedbackData.map((feedback, index) => ({
        ...feedback,
        id:
          feedback.appraisal_feedback_id ||
          feedback.feedback_id ||
          feedback.id ||
          index,
      }));

      setProjects(processedData);
      setTotalRecords(feedbackData.length);
    } catch (error) {
      toast.error(error.message || "Search failed");
      setProjects([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
      setIsSearching(false);
    }
  };

  // FIXED: Updated fetchProjects function 
  // const fetchProjects = async () => {
  //   setLoading(true);
  //   // Reset advanced filter payload when fetching all
  //   setFilterPayload(null);
  //   sessionStorage.removeItem("appraisalFilter");

  //   try {
  //     const response = await fetchAllEntities(
  //       "appraisalFeedback/getAppraisalFeedbacks"
  //     );

  //     let feedbackList = [];
  //     if (response.status) {
  //       if (
  //         response.data &&
  //         response.data.data &&
  //         Array.isArray(response.data.data)
  //       ) {
  //         feedbackList = response.data.data;
  //         setTotalRecords(response.data.total || response.data.data.length);
  //       } else if (Array.isArray(response.data)) {
  //         feedbackList = response.data;
  //         setTotalRecords(response.data.length);
  //       }
  //     }

  //     // Make sure each item has an ID for DataGrid
  //     const processedData = feedbackList.map((feedback, index) => ({
  //       ...feedback,
  //       id:
  //         feedback.appraisal_feedback_id ||
  //         feedback.feedback_id ||
  //         feedback.id ||
  //         index, // Use appraisal_feedback_id as primary ID
  //     }));

  //     setProjects(processedData);
  //      console.log("appraisal_feedback", processedData);

  //     if (feedbackList.length > 0) {
  //       console.log(`${feedbackList.length} feedback records loaded`);
  //     }
  //   } catch (error) {
  //     console.error("Fetch error:", error);
  //     toast.error(error.message || "Failed to fetch appraisal feedback");
  //     setProjects([]);
  //     setTotalRecords(0);
  //   } finally {
  //     setLoading(false);
  //     setClearFilter(false);
  //   }
  // };

  //   const fetchProjects = async () => {
  //   setLoading(true);

  //   try {
  //     const params = {
  //       feedback_type: filter === "all_feedback" ? null : filter,
  //     };

  //     const response = await fetchAllEntities(
  //       "appraisalFeedback/getAppraisalFeedbacks",
  //       params
  //     );

  //     let feedbackList = [];

  //     if (response.status) {
  //       if (response.data?.data && Array.isArray(response.data.data)) {
  //         feedbackList = response.data.data;
  //         setTotalRecords(response.data.total || response.data.data.length);
  //       } else if (Array.isArray(response.data)) {
  //         feedbackList = response.data;
  //         setTotalRecords(response.data.length);
  //       }
  //     }

  //     const processedData = feedbackList.map((feedback, index) => ({
  //       ...feedback,
  //       id:
  //         feedback.appraisal_feedback_id ||
  //         feedback.feedback_id ||
  //         feedback.id ||
  //         index,
  //     }));

  //     setProjects(processedData);
  //   } catch (error) {
  //     toast.error(error.message || "Failed to fetch appraisal feedback");
  //     setProjects([]);
  //     setTotalRecords(0);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const fetchProjects = async (filterValue = null) => {
    setLoading(true);

    try {
      // Use the passed filter value or fallback to state
      const currentFilter = filterValue !== null ? filterValue : filter;

      // Check if there are any advanced filters applied
      const storedFilters = sessionStorage.getItem("appraisalFilter");
      const hasAdvancedFilters = storedFilters && JSON.parse(storedFilters) &&
        Object.keys(JSON.parse(storedFilters)).length > 0;

      const params = {
        feedback_type: currentFilter === "all_feedback" ? null : currentFilter,
      };

      // If advanced filters exist, merge them
      if (hasAdvancedFilters) {
        const parsedFilters = JSON.parse(storedFilters);
        Object.assign(params, parsedFilters);

        // Ensure feedback_type from parameter overrides any feedback_type from advanced filters
        params.feedback_type = currentFilter === "all_feedback" ? null : currentFilter;
      }

      const response = await filterEntities(
        "appraisalFeedback/getAppraisalFeedbacks",
        params
      );

      let feedbackList = [];

      if (response.status) {
        if (response.data?.data && Array.isArray(response.data.data)) {
          feedbackList = response.data.data;
          setTotalRecords(response.data.total || response.data.data.length);
        } else if (Array.isArray(response.data)) {
          feedbackList = response.data;
          setTotalRecords(response.data.length);
        }
      }

      const processedData = feedbackList.map((feedback, index) => ({
        ...feedback,
        id:
          feedback.appraisal_feedback_id ||
          feedback.feedback_id ||
          feedback.id ||
          index,
      }));

      setProjects(processedData);
    } catch (error) {
      toast.error(error.message || "Failed to fetch appraisal feedback");
      setProjects([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };

  // // Option : Export functionality
  const location = useLocation();

  // 🔥 Close SweetAlert when route changes (sidebar click)
  useEffect(() => {
    Swal.close();
  }, [location]);

  // 🔥 Close SweetAlert when component unmounts
  useEffect(() => {
    return () => {
      Swal.close();
    };
  }, []);
  // const handleExportClick = async (event) => {
  //   event.preventDefault();
  //   event.stopPropagation();

  //   // Check if export icon exists
  //   const exportIcon = document.querySelector(
  //     ".project-icon-bg .text-rgbr-blue"
  //   );
  //   if (!exportIcon) {
  //     console.warn("Export icon not found");
  //     // return; // Don't return, allow function to proceed
  //   }

  //   // Show confirmation popup
  //   const result = await Swal.fire({
  //     title: "Export Confirmation",
  //     text: "Are you sure you want to export?",
  //     icon: "question",
  //     showCancelButton: true,
  //     confirmButtonText: "Export",
  //     cancelButtonText: "Cancel",
  //     confirmButtonColor: "#04a189",
  //     cancelButtonColor: "#d33",
  //   });

  //   if (result.isConfirmed) {
  //     await handleExport();
  //   }
  //   Swal.close(); // Close any existing popup before opening new one
  // };

  const handleExportClick = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    // Close any existing popup first
    Swal.close();

    const result = await Swal.fire({
      title: "Export Confirmation",
      text: "Are you sure you want to export?",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Export",
      cancelButtonText: "Cancel",
      confirmButtonColor: "#04a189",
      cancelButtonColor: "#d33",

      // ✅ Important Fix
      allowOutsideClick: true,
      allowEscapeKey: true,
      backdrop: true,
    });

    if (result.isConfirmed) {
      await handleExport();
    }
  };

  // FIXED: Updated Handle Export to properly handle project and user filters
  const handleExport = async (event) => {
    setLoading(true);

    // NEW: Early exit if no data to export
    if (!projects || projects.length === 0) {
      toast.error("No data available to export");
      setLoading(false);
      return;
    }

    try {
      // Check if there are any stored filters in sessionStorage
      const storedFilters = sessionStorage.getItem("appraisalFilter");
      const parsedFilters = storedFilters ? JSON.parse(storedFilters) : {};

      // Build export parameters
      let exportParams = {
        isExport: 1,
      };

      // IMPORTANT FIX: Properly add advanced filters if they exist
      if (Object.keys(parsedFilters).length > 0) {
        // Copy all filter parameters
        exportParams = {
          ...exportParams,
          ...parsedFilters
        };

        // Log for debugging
        // console.log("Exporting with stored filters:", parsedFilters);
        // console.log("Export params after merging:", exportParams);
      }

      // Add basic filter (dropdown) if not "all_feedback"
      if (filter && filter !== "all_feedback") {
        exportParams.feedback_type = filter;
      }

      // Add search term if exists
      if (searchTerm.trim()) {
        exportParams.search = searchTerm;
      }

      // FIX: Ensure project_id and user_id are properly formatted if they exist
      if (exportParams.project_id) {
        exportParams.project_id = parseInt(exportParams.project_id);
      }
      if (exportParams.user_id) {
        exportParams.user_id = parseInt(exportParams.user_id);
      }

      // CRITICAL FIX: Add department_id parsing if it exists
      if (exportParams.department_id) {
        exportParams.department_id = parseInt(exportParams.department_id);
      }

      // ADD THIS: If department filter might be using a different key name
      // Check for common department filter key names
      if (parsedFilters.department) {
        exportParams.department_id = parsedFilters.department;
      }
      if (parsedFilters.department_name) {
        exportParams.department_name = parsedFilters.department_name;
      }
      if (parsedFilters.departmentId) {
        exportParams.department_id = parsedFilters.departmentId;
      }

      // console.log("Final export parameters before API call:", exportParams);

      // Make API call with all parameters
      const response = await filterEntities(
        "appraisalFeedback/getAppraisalFeedbacks",
        exportParams
      );

      if (response.status && response.data) {
        const fileUrl = response.data.fileUrl;

        if (fileUrl) {
          // Create a link element
          const link = document.createElement("a");
          link.href = fileUrl;

          // Extract filename from URL or use default
          const fileName = fileUrl.split('/').pop() ||
            `AppraisalFeedback_${new Date().toISOString().split("T")[0]}.xlsx`;

          // Set download attribute with the original filename from server
          link.download = fileName;

          // Append to body, click, and remove
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);

          toast.success(response.data.message || "Appraisal Feedback exported successfully");
        } else {
          toast.warning("File URL not found in response");
          // Fallback to client-side export if API doesn't provide file
          exportData();
        }
      } else {
        toast.error(response?.message || "Export failed, no data returned");
        // Fallback to client-side export
        exportData();
      }
    } catch (error) {
      console.error("Export error:", error);
      toast.error(error.message || "Export failed, trying client-side export");
      // Fallback to client-side export
      exportData();
    } finally {
      setLoading(false);
    }
  };

  // Client-side CSV export backup
  const exportData = async () => {
    try {
      // Convert data to CSV
      const csvData = convertToCSV(projects);
      // Create and download CSV file
      const currentDate = new Date().toISOString().split("T")[0];
      const fileName = `appraisal_feedback_${currentDate}.csv`;
      downloadCSV(csvData, fileName);
      toast.success("Export completed successfully!");
    } catch (error) {
      console.error("Export error:", error);
      toast.error("Export failed: " + error.message);
    }
  };

  const convertToCSV = (data) => {
    if (!data || data.length === 0) return "";

    const headers = [
      "Appraisal ID",
      "User Name",
      "Department",
      "Project Name",
      "Feedback Type",
      "Date of Incident",
      "Comments",
      "Remarks",
      "Image Evidence",
      "Added At",
      "Added By",
      "Updated At",
      "Updated By",
    ];

    // Map values from backend to use frontend table format
    const rows = data.map((item) => [
      item.appraisal_feedback_id || item.id || "",
      item.user_name || "",
      item.department_name || "",
      item.project_name || "",
      item.feedback_type || "",
      item.date_of_incident || "",
      item.comments
        ? String(item.comments).replace(/<[^>]*>/g, "").replace(/,/g, ";")
        : "",
      item.remarks ? String(item.remarks).replace(/,/g, ";") : "",

      //  REMOVE HYPERLINK COMPLETELY
      item.image_evidence
        ? `${item.user_name || "User"} Image Evidence`
        : "",

      //  Correct field names from API
      item.added_at || "",
      item.added_by || "",
      item.updated_at || "",
      item.updated_by || "",
    ]);

    return [
      headers.join(","),
      ...rows.map((row) =>
        row.map((cell) => `"${cell ?? ""}"`).join(",")
      ),
    ].join("\n");
  };

  const downloadCSV = (csvContent, fileName) => {
    const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.setAttribute("download", fileName);
    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };



  useEffect(() => {
    if (!isSearching) {
      fetchProjects();
    }
    // eslint-disable-next-line
  }, []);

  //-----------today------------
  //   useEffect(() => {
  //   if (isFilterChanging.current) {
  //     isFilterChanging.current = false;
  //     return;
  //   }

  //   const fetchData = async () => {
  //     setLoading(true);
  //     try {
  //       const response = await fetchAllEntities(
  //         "appraisalFeedback/getAppraisalFeedbsssacks",
  //         {
  //           feedback_type: filter === "all_feedback" ? null : filter,
  //         }
  //       );

  //       if (response.status && response.data) {
  //         let feedbackData = response.data.data || response.data || [];

  //         const processedData = feedbackData.map((feedback, index) => ({
  //           ...feedback,
  //           id:
  //             feedback.appraisal_feedback_id ||
  //             feedback.feedback_id ||
  //             feedback.id ||
  //             index,
  //         }));

  //         setProjects(processedData);
  //         setTotalRecords(feedbackData.length);
  //       }
  //     } catch (error) {
  //       console.error("Fetch error:", error);
  //     } finally {
  //       setLoading(false);
  //     }
  //   };

  //   fetchData();
  // }, [filter]);

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     if (searchTerm.trim()) {
  //       fetchSearchedProjects(searchTerm.trim());
  //     } else {
  //       fetchProjects();
  //     }
  //   }, 500);

  //   return () => clearTimeout(delayDebounce);
  //   // eslint-disable-next-line
  // }, [searchTerm, filter]);

  // useEffect(() => {
  //   const delayDebounce = setTimeout(() => {
  //     if (searchTerm.trim()) {
  //       fetchSearchedProjects(searchTerm.trim());
  //     }
  //   }, 500);

  //   return () => clearTimeout(delayDebounce);
  // }, [searchTerm]);

  // Effect for search changes only
  useEffect(() => {
    const delayDebounce = setTimeout(() => {
      if (searchTerm.trim()) {
        fetchSearchedProjects(searchTerm.trim());
      } else {
        // When search is cleared, fetch projects with current filter
        fetchProjects();
      }
    }, 500);

    return () => clearTimeout(delayDebounce);
  }, [searchTerm]); // Only depends on searchTerm

  // Effect for filter changes only
  useEffect(() => {
    // Don't run if we're currently searching
    if (!searchTerm.trim()) {
      fetchProjects();
    }
  }, [filter]); // Only depends on filter


  //-----------today------------

  // const handleFilterChange = async (event) => {
  //   const value = event.target.value;
  //   clearGlobalSearch(); 
  //   setFilter(value);
  //   setLoading(true);

  //   try {
  //     // Check if there are any advanced filters applied
  //     const storedFilters = sessionStorage.getItem("appraisalFilter");
  //     const hasAdvancedFilters = storedFilters && JSON.parse(storedFilters) && 
  //                                Object.keys(JSON.parse(storedFilters)).length > 0;

  //     // Build params - include both dropdown filter AND advanced filters if they exist
  //     const params = {
  //       feedback_type: value === "all_feedback" ? null : value,
  //     };

  //     // If advanced filters exist, merge them with the dropdown filter
  //     if (hasAdvancedFilters) {
  //       const parsedFilters = JSON.parse(storedFilters);

  //       // Merge the filters - dropdown filter should take precedence if there's a conflict
  //       // But we want to keep project, user, department, etc. filters
  //       Object.assign(params, parsedFilters);

  //       // Ensure feedback_type from dropdown overrides any feedback_type from advanced filters
  //       params.feedback_type = value === "all_feedback" ? null : value;
  //     }

  //     const response = await fetchAllEntities(
  //       "appraisalFeedback/getAppraisalFeedbacks",
  //       params
  //     );

  //     if (response.status && response.data) {
  //       let feedbackData = response.data.data || response.data || [];
  //       const processedData = feedbackData.map((feedback, index) => ({
  //         ...feedback,
  //         id:
  //           feedback.appraisal_feedback_id ||
  //           feedback.feedback_id ||
  //           feedback.id ||
  //           index,
  //       }));
  //       setProjects(processedData);
  //       setTotalRecords(feedbackData.length);
  //     }
  //   } catch (error) {
  //     console.error("Filter error:", error);
  //     toast.error(error.message || "Filter failed");
  //     setProjects([]);
  //     setTotalRecords(0);
  //   } finally {
  //     setLoading(false);
  //   }
  // };

  const handleFilterChange = async (event) => {
    const value = event.target.value;
    clearGlobalSearch();
    setFilter(value);

    isFilterChanging.current = true;   // ✅ ADD THIS LINE

    setLoading(true);

    try {
      const storedFilters = sessionStorage.getItem("appraisalFilter");
      const hasAdvancedFilters =
        storedFilters &&
        JSON.parse(storedFilters) &&
        Object.keys(JSON.parse(storedFilters)).length > 0;

      const params = {
        feedback_type: value === "all_feedback" ? null : value,
      };

      if (hasAdvancedFilters) {
        const parsedFilters = JSON.parse(storedFilters);
        Object.assign(params, parsedFilters);
        params.feedback_type = value === "all_feedback" ? null : value;
      }

      const response = await filterEntities(
        "appraisalFeedback/getAppraisalFeedbacks",
        params
      );

      if (response.status && response.data) {
        let feedbackData = response.data.data || response.data || [];
        const processedData = feedbackData.map((feedback, index) => ({
          ...feedback,
          id:
            feedback.appraisal_feedback_id ||
            feedback.feedback_id ||
            feedback.id ||
            index,
        }));
        setProjects(processedData);
        setTotalRecords(feedbackData.length);
      }
    } catch (error) {
      console.error("Filter error:", error);
      toast.error(error.message || "Filter failed");
      setProjects([]);
      setTotalRecords(0);
    } finally {
      setLoading(false);
    }
  };


  const handleSearchChange = (event) => {
    setSearchTerm(event.target.value);
  };



  // FIXED: Updated to capture filter payload
  // FIXED: Updated to capture filter payload
  //   const handleApplyFilter = (filteredData, queryParams) => {
  //   console.log("Applying filter with data:", filteredData);

  //   let feedbackData
  //  = [];
  //   let isDataFromAPI = false;

  //   if (filteredData) {
  //     // Check if data is coming from API response
  //     if (filteredData.data && Array.isArray(filteredData.data)) {
  //       feedbackData = filteredData.data;
  //       isDataFromAPI = true;
  //     } else if (Array.isArray(filteredData)) {
  //       feedbackData = filteredData;
  //       isDataFromAPI = true;
  //     }
  //   }

  //   console.log("Processed feedback data:", feedbackData);

  //   const processedData = feedbackData.map((feedback, index) => ({
  //     ...feedback,
  //     id:
  //       feedback.appraisal_feedback_id ||
  //       feedback.feedback_id ||
  //       feedback.id ||
  //       index,
  //   }));

  //   setProjects(processedData);
  //   setTotalRecords(feedbackData.length);
  //   setShowFilter(false);
  //   setClearFilter(true);

  //   // STORE THE ADVANCED FILTERS in state
  //   if (queryParams) {
  //     setFilterPayload(queryParams);
  //   }

  //   // Show appropriate toast message
  //   if (isDataFromAPI) {
  //     if (feedbackData.length === 0) {
  //       toast.info("No matching records found with the applied filters");
  //     } else {
  //       toast.success(`Found ${feedbackData.length} records with the applied filters`);
  //     }
  //   } else {
  //     // If no data was provided at all
  //     toast.error("Failed to apply filters. Please try again.");
  //   }
  // };

  // FIXED: Updated to capture filter payload
  // const handleApplyFilter = (filteredData, queryParams) => {
  //   console.log("Applying filter with data:", filteredData);

  //   clearGlobalSearch(); // 🔥 CLEAR SEARCH
  //   let feedbackData = [];
  //   let isDataFromAPI = false;

  //   if (filteredData) {
  //     // Check if data is coming from API response
  //     if (filteredData.data && Array.isArray(filteredData.data)) {
  //       feedbackData = filteredData.data;
  //       isDataFromAPI = true;
  //     } else if (Array.isArray(filteredData)) {
  //       feedbackData = filteredData;
  //       isDataFromAPI = true;
  //     }
  //   }

  //   console.log("Processed feedback data:", feedbackData);

  //   const processedData = feedbackData.map((feedback, index) => ({
  //     ...feedback,
  //     id:
  //       feedback.appraisal_feedback_id ||
  //       feedback.feedback_id ||
  //       feedback.id ||
  //       index,
  //   }));

  //   setProjects(processedData);
  //   setTotalRecords(feedbackData.length);
  //   setShowFilter(false);
  //   setClearFilter(true);

  //   // STORE THE ADVANCED FILTERS in state
  //   if (queryParams) {
  //     setFilterPayload(queryParams);

  //     // NEW: Update the main filter dropdown based on queryParams
  //     if (queryParams.feedback_type) {
  //       // Map the feedback_type to corresponding filter value
  //       setFilter(queryParams.feedback_type); // This will update the dropdown
  //     } else if (queryParams.feedback_types) {
  //       // Handle array case if needed
  //       setFilter(queryParams.feedback_types[0] || "all_feedback");
  //     } else {
  //       // If no feedback_type is specified in queryParams, reset to "All Feedback"
  //       setFilter("all_feedback");
  //     }
  //   } else {
  //     // If no queryParams at all, reset to "All Feedback"
  //     setFilter("all_feedback");
  //   }

  //   // Show appropriate toast message
  //   if (isDataFromAPI) {
  //     if (feedbackData.length === 0) {
  //       toast.info("No matching records found with the applied filters");
  //     } else {
  //       toast.success(`Found ${feedbackData.length} records with the applied filters`);
  //     }
  //   } else {
  //     // If no data was provided at all
  //     toast.error("Failed to apply filters. Please try again.");
  //   }
  // };

  // const handleApplyFilter = (filteredData, queryParams) => {
  //   console.log("Applying filter with data:", filteredData);

  //   clearGlobalSearch(); // 🔥 CLEAR SEARCH

  //   // filteredData is already the filtered array from the filter component
  //   const feedbackData = Array.isArray(filteredData) ? filteredData : [];

  //   console.log("Processed feedback data:", feedbackData);

  //   const processedData = feedbackData.map((feedback, index) => ({
  //     ...feedback,
  //     id:
  //       feedback.appraisal_feedback_id ||
  //       feedback.feedback_id ||
  //       feedback.id ||
  //       index + 1,
  //   }));

  //   setProjects(processedData);
  //   setTotalRecords(feedbackData.length);
  //   setShowFilter(false);
  //   setClearFilter(true);

  //   // STORE THE ADVANCED FILTERS in state
  //   if (queryParams) {
  //     setFilterPayload(queryParams);

  //     // Update the main filter dropdown based on queryParams
  //     if (queryParams.feedback_type) {
  //       setFilter(queryParams.feedback_type);
  //     } else {
  //       setFilter("all_feedback");
  //     }
  //   } else {
  //     setFilter("all_feedback");
  //   }

  //   // Show appropriate toast message
  //   if (feedbackData.length === 0) {
  //     toast.info("No matching records found with the applied filters");
  //   } else {
  //     toast.success(`Found ${feedbackData.length} records with the applied filters`);
  //   }
  // };

  const handleApplyFilter = (filteredData, queryParams) => {
    // console.log("Applying filter with data:", filteredData);

    clearGlobalSearch(); // 🔥 CLEAR SEARCH

    const feedbackData = Array.isArray(filteredData) ? filteredData : [];

    // console.log("Processed feedback data:", feedbackData);

    const processedData = feedbackData.map((feedback, index) => ({
      ...feedback,
      id:
        feedback.appraisal_feedback_id ||
        feedback.feedback_id ||
        feedback.id ||
        index + 1,
    }));

    setProjects(processedData);
    setTotalRecords(feedbackData.length);
    setShowFilter(false);

    // Only set clearFilter to true if there are actual filters applied
    if (queryParams && Object.keys(queryParams).length > 0) {
      setClearFilter(true);
      setFilterPayload(queryParams);

      // Update the main filter dropdown based on queryParams
      if (queryParams.feedback_type) {
        setFilter(queryParams.feedback_type);
      } else {
        setFilter("all_feedback");
      }
    } else {
      // No filters applied
      setClearFilter(false);
      setFilterPayload(null);
      setFilter("all_feedback");
    }

    // Show appropriate toast message
    if (feedbackData.length === 0) {
      toast.info("No matching records found with the applied filters");
    } else {
      toast.success(`Found ${feedbackData.length} records with the applied filters`);
    }
  };

  //   const handleClearFilter = () => {
  //   setFilterPayload(null);
  //   setFilter("all_feedback");
  //   setClearFilter(false);   // 👈 ADD THIS LINE
  //   sessionStorage.removeItem("appraisalFilter");
  //   fetchProjects();
  // };

  // const handleClearFilter = () => {
  //   setFilterPayload(null);
  //   setFilter("all_feedback");
  //   setClearFilter(false);

  //   // 🔥 ADD THIS
  //   setSearchTerm("");     
  //   setIsSearching(false); 

  //   sessionStorage.removeItem("appraisalFilter");
  //   fetchProjects();
  // };

  const handleClearFilter = () => {
    // First clear all filters
    sessionStorage.removeItem("appraisalFilter");

    // Then reset all states
    setFilterPayload(null);
    setClearFilter(false);
    setSearchTerm("");
    setIsSearching(false);

    // Set filter to all_feedback
    setFilter("all_feedback");

    // Fetch all records immediately with "all_feedback" parameter
    fetchProjects("all_feedback");
  };


  const handleShowProject = () => {
    clearGlobalSearch(); // 🔥 CLEAR SEARCH
    setIsEdit(false);
    setEditData(null);
    setShowProject(true);
  };

  const handleCancel = () => {
    setShowProject(false);
    setIsEdit(false);
    setEditData(null);
  };

  // useEffect(() => {
  //   sessionStorage.setItem("isFilterApplied", false);
  //   sessionStorage.removeItem("filtered_data");
  //   fetchProjects();
  //   // eslint-disable-next-line
  // }, []);

  //  🔥🔥🔥 CLEAR GLOBAL SEARCH FUNCTION
  const clearGlobalSearch = () => {
    setSearchTerm("");
    setIsSearching(false);
  };


  return (
    <>
      <Offcanvas
        show={showProject}
        placement="end"
        className="custom-offcanvas"
        style={{ width: window.innerWidth <= 768 ? "90%" : "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <AddAppraisalFeedback
            onCancel={handleCancel}
            fetchProjects={fetchProjects}
            editData={editData}
            isEdit={isEdit}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Offcanvas
        show={showFilter}
        placement="end"
        style={{ width: window.innerWidth <= 768 ? "80%" : "50%" }}
      >
        <Offcanvas.Body className="p-0">
          <FilterAppraisalFeedback
            onApply={handleApplyFilter}
            onCancel={() => setShowFilter(false)}
          />
        </Offcanvas.Body>
      </Offcanvas>

      <Menu
        anchorEl={menuAnchorEl}
        open={Boolean(menuAnchorEl)}
        onClose={() => setMenuAnchorEl(null)}
        disableAutoFocus={true}
        disableEnforceFocus={true}
      >


        {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
          [
            <MenuItem key="edit" onClick={handleEdit}>
              <ListItemIcon sx={{ color: "#0d6efd" }}>
                <CiEdit size={22} color="#0d6efd" />
              </ListItemIcon>
              <ListItemText primary="Edit Appraisal" />
            </MenuItem>,
            <MenuItem key="delete" onClick={handleDelete}>
              <ListItemIcon sx={{ color: "#ed2828ff" }}>
                <RiDeleteBin5Line size={18} color="#ed2828ff" />
              </ListItemIcon>
              <ListItemText primary="Delete Appraisal" />
            </MenuItem>
          ]
        )}
      </Menu>

      <div className={`container-fluid ${isDarkMode ? "project-drawer-bg text-white" : "bg-white"} p-3`}>
        {/*  */}
        {/* <div className="row align-items-center pb-2">
          <div className="col-12 col-lg-2 col-md-4">
            <FormControl className="pb-2">
              <Select value={filter} onChange={handleFilterChange}>
                {filterOptions.map((option) => (
                  <MenuItem key={option.value} value={option.value}>
                    {option.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
          </div>

          <div className="col-12 col-lg-10 col-md-8 d-flex flex-wrap justify-content-md-end gap-2">
            <SearchBar
              placeholder="Search"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />

            {clearFilter && (
              <button
                className="addmore_btn"
                disabled={loading}
                onClick={handleClearFilter}
              >
                Clear Filter
              </button>
            )}

            {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
              <Button
                className="rounded text-capitalize AddButton me-3 ms-2"
                onClick={handleShowProject}>
                Add Feedback
              </Button>
            )}
            

            <button
              className="border-0 p-2 rounded-circle text-decoration-none me-3 project-icon-bg"
              onClick={() => setShowFilter(true)}
             
            >
              <CiFilter className="text-rgbr-blue pro-icon-s"/>
            </button>

            <button
              className="border-0 p-2 rounded-circle text-decoration-none me-3 project-icon-bg"
              onClick={handleExportClick}
              disabled={loading}
            >
              <Tooltip title="Export">
                <MdOutlineFileDownload className="text-rgbr-blue pro-icon-s" />
              </Tooltip>
            </button>
          </div>
        </div> */}

        <Box
          sx={{
            display: "flex",
            flexDirection: { xs: "column", sm: "row" },
            flexWrap: { xs: "wrap", md: "nowrap" },
            alignItems: { xs: "stretch", sm: "center" },
            justifyContent: "space-between",
            gap: 2,
            width: "100%",
            border: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
            borderRadius: "6px",
            padding: "12px 16px",
            marginBottom: "3px",
            backgroundColor: isDarkMode ? "transparent" : "#fff",
          }}
        >
          <div className="d-flex align-items-center">
            <FormControl sx={{ minWidth: { xs: "100%", sm: "auto" }, width: "auto" }} size="small">
              <Select value={filter} onChange={handleFilterChange}>
                {filterPayload?.feedback_type ? (
                  filterPayload.feedback_type === "positive" ? (
                    <MenuItem value="positive">Positive Feedback</MenuItem>
                  ) : (
                    <MenuItem value="negative">Negative Feedback</MenuItem>
                  )
                ) : (
                  filterOptions.map((option) => (
                    <MenuItem key={option.value} value={option.value}>
                      {option.label}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </div>

          <div className="d-flex flex-wrap align-items-center justify-content-md-end gap-2">
            <SearchBar
              placeholder="Search"
              searchTerm={searchTerm}
              onSearchChange={handleSearchChange}
            />

            {clearFilter && (
              <button
                className="addmore_btn"
                disabled={loading}
                onClick={handleClearFilter}
              >
                Clear Filter
              </button>
            )}

            {(login_user_role === "ADMIN" || login_user_role === "MANAGER") && (
              <Button
                className="rounded text-capitalize AddButton me-2 px-3"
                onClick={handleShowProject}
                style={{ height: 40 }}
              >
                Add Feedback
              </Button>
            )}

            <Tooltip title="Filter">
              <IconButton
                sx={{
                  borderRadius: "50%",
                  width: "38px",
                  height: "38px",
                  margin: "0 12px 0 12px",
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
                onClick={() => setShowFilter(true)}
              >
                <CiFilter className="text-rgbr-blue" style={{ fontSize: "23px" }} />
              </IconButton>
            </Tooltip>

            <Tooltip title="Export" >
              <IconButton
                sx={{
                  borderRadius: "50%",
                  width: "38px",
                  height: "38px",
                  backgroundColor: isDarkMode
                    ? "rgba(67, 105, 255, 0.08)"
                    : "#F1F5FF",
                  "&:hover": {
                    backgroundColor: "var(--icon-hover-bg)",
                  },
                }}
                onClick={handleExportClick}
                disabled={loading}
              >
                <CiExport className="text-rgbr-blue" style={{ fontSize: "23px" }} />
              </IconButton>
            </Tooltip>
          </div>
        </Box>

        {loading ? (
          <Loader />
        ) : (
          <div className="row">
            <div className="col-12">
              <FilterSummaryBox
                onApply={handleApplyFilter}
                status_type={"PROJECT"}
                filter_path="/appraisalFeedback/filter"
              />
            </div>
            <div className="col-12 mt-3">
              <Box
                sx={{
                  // height: projects.length === 0 ? 300 : "100%",
                  width: "100%",
                }}
              >
                <DataGrid
                  rows={Array.isArray(projects) ? projects : []}
                  columns={projectColumns}
                  loading={loading}
                  disableColumnMenu  //added  disableColumnMenu for hide 3 dots for each header cells
                  slots={{ noRowsOverlay: CustomNoRowsOverlay }}
                  getRowId={(row) =>
                    row.id ||
                    row.appraisal_feedback_id ||
                    row.feedback_id ||
                    Math.random()
                  }
                  onRowClick={(params) => {
                    setSelectedRecord(params.row);
                    setShowDetailModal(true);
                  }}
                  pagination
                  pageSizeOptions={[10, 20, 30, 40]}
                  paginationModel={paginationModel}
                  onPaginationModelChange={setPaginationModel}
                  // rowCount={totalRecords}
                  paginationMode="client"
                  sx={{
                    border: `1px solid ${isDarkMode ? "#333" : "#e0e0e0"}`,
                    maxWidth: "100%",
                    overflowX: "auto",
                    "& .MuiDataGrid-cell": {
                      borderBottom: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                      borderRight: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                      color: isDarkMode ? "#fff" : "inherit",
                    },
                    "& .MuiDataGrid-columnHeaders": {
                      borderBottom: isDarkMode ? "2px solid #333" : "2px solid #e0e0e0",
                      backgroundColor: isDarkMode ? "#1d1d1d" : "#fafafa",
                    },
                    "& .MuiDataGrid-columnHeader": {
                      color: isDarkMode ? "#fff" : "inherit",
                    },
                    "& .MuiDataGrid-row:nth-of-type(even)": {
                      backgroundColor: isDarkMode ? "#1d1d1d" : "#fafafa",
                    },
                    "& .MuiDataGrid-row:hover": {
                      backgroundColor: isDarkMode ? "#2d2d2d !important" : "#f5f5f5 !important",
                    },
                    backgroundColor: isDarkMode ? "project-drawer-bg" : "inherit",
                    "& .MuiDataGrid-columnHeaderTitle": {
                      color: isDarkMode ? "#fff" : "inherit",
                      fontWeight: 600
                    },
                    "& .MuiDataGrid-footerContainer": {
                      backgroundColor: isDarkMode ? "project-drawer-bg" : "inherit",
                      color: isDarkMode ? "#fff" : "inherit",
                      borderTop: isDarkMode ? "1px solid #333" : "1px solid #e0e0e0",
                    },
                    "& .MuiTablePagination-root": {
                      color: isDarkMode ? "#fff" : "inherit",
                    }
                  }}
                />
              </Box>
            </div>
          </div>

        )}
      </div>

      {/* Record Detail Modal (Profile Card Style) */}
      <Dialog
        open={showDetailModal}
        onClose={() => setShowDetailModal(false)}
        maxWidth="sm"
        fullWidth
        PaperProps={{
          sx: {
            backgroundColor: isDarkMode ? "#111827" : "#ffffff",
            color: isDarkMode ? "#ffffff" : "#111827",
            borderRadius: "10px",
            padding: "12px",
            border: isDarkMode ? "1px solid #374151" : "1px solid #e5e7eb",
            boxShadow: "0 25px 50px -12px rgba(0, 0, 0, 0.25)",
            position: "relative",
          },
        }}
      >
        <DialogTitle sx={{ m: 0, p: 2 }}>
          <IconButton
            aria-label="close"
            onClick={() => setShowDetailModal(false)}
            sx={{
              position: 'absolute',
              right: 8,
              top: 8,
              color: isDarkMode ? "#9ca3af" : "#6b7280",
              transition: "all 0.2s ease-in-out",
              "&:hover": {
                backgroundColor: isDarkMode ? "rgba(255, 255, 255, 0.08)" : "rgba(0, 0, 0, 0.04)",
                color: isDarkMode ? "#d1d5db" : "#4b5563",
              }
            }}
          >
            <MdClose />
          </IconButton>
        </DialogTitle>
        <DialogContent sx={{ pt: 2, pb: 4 }}>
          <Box display="flex" flexDirection="column" alignItems="center" sx={{ mb: 3 }}>
            {/* Circle Profile Image */}
            <Box
              sx={{
                width: "120px",
                height: "120px",
                borderRadius: "50%",
                border: `4px solid rgba(18, 183, 159, 1)`,
                overflow: "hidden",
                backgroundColor: isDarkMode ? "#1f2937" : "#f3f4f6",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                mb: 2,
                boxShadow: "0 4px 6px -1px rgba(0, 0, 0, 0.1)",
              }}
            >
              {(() => {
                let evidence = selectedRecord?.image_evidence;
                let imageUrl = "";
                if (Array.isArray(evidence) && evidence.length > 0) {
                  imageUrl = evidence[0].url || (typeof evidence[0] === 'string' ? evidence[0] : "");
                } else if (typeof evidence === "string") {
                  imageUrl = evidence;
                }

                if (imageUrl) {
                  const BASE_URL = (process.env.REACT_APP_API_BASE_URL || "").replace(/\/api\/v2\/?$/, "");
                  const fullUrl = imageUrl.startsWith("http")
                    ? imageUrl
                    : `${BASE_URL}${imageUrl.startsWith("/") ? "" : "/"}${imageUrl.replace(/\/storage\/\/storage\//g, "/storage/")}`;

                  return (
                    <img
                      src={fullUrl}
                      alt="Profile"
                      style={{ width: "100%", height: "100%", objectFit: "cover" }}
                    />
                  );
                }
                return (
                  <Avatar
                    sx={{
                      width: "100%",
                      height: "100%",
                      fontSize: "3rem",
                      bgcolor: "rgba(18, 183, 159, 1)",
                    }}
                  >
                    {selectedRecord?.user_name ? selectedRecord.user_name.charAt(0).toUpperCase() : "?"}
                  </Avatar>
                );
              })()}
            </Box>

            {/* Name and Type */}
            <Typography variant="h5" sx={{ fontWeight: "700", mb: 0.5, color: isDarkMode ? "#f3f4f6" : "#111827" }}>
              {selectedRecord?.user_name || ""}
            </Typography>
            <Box
              sx={{
                backgroundColor: selectedRecord?.feedback_type?.toLowerCase() === "positive"
                  ? (isDarkMode ? "rgba(18, 183, 159, 0.2)" : "rgba(18, 183, 159, 0.1)")
                  : selectedRecord?.feedback_type?.toLowerCase() === "negative"
                    ? (isDarkMode ? "rgba(220, 38, 38, 0.2)" : "rgba(220, 38, 38, 0.1)")
                    : (isDarkMode ? "rgba(18, 183, 159, 0.2)" : "rgba(18, 183, 159, 0.1)"),
                color: selectedRecord?.feedback_type?.toLowerCase() === "positive"
                  ? "rgba(18, 183, 159, 1)"
                  : selectedRecord?.feedback_type?.toLowerCase() === "negative"
                    ? "rgba(220, 38, 38, 1)"
                    : "rgba(18, 183, 159, 1)",
                padding: "4px 16px",
                borderRadius: "20px",
                fontSize: "12px",
                fontWeight: "700",
                textTransform: "uppercase",
                letterSpacing: "0.5px",
                border: selectedRecord?.feedback_type?.toLowerCase() === "positive"
                  ? "1px solid rgba(18, 183, 159, 0.3)"
                  : selectedRecord?.feedback_type?.toLowerCase() === "negative"
                    ? "1px solid rgba(220, 38, 38, 0.3)"
                    : "1px solid rgba(18, 183, 159, 0.3)",
              }}
            >
              {selectedRecord?.feedback_type
                ? `${selectedRecord.feedback_type.toUpperCase()} FEEDBACK`
                : "FEEDBACK"}
            </Box>
          </Box>

          <Box display="flex" flexDirection="column" gap={2}>
            {[
              { label: "Appraisal ID", value: selectedRecord?.appraisal_feedback_id || selectedRecord?.feedback_id || selectedRecord?.id },
              { label: "Department", value: selectedRecord?.department_name },
              { label: "Project Name", value: selectedRecord?.project_name },
              {
                label: "Date of Incident",
                value: selectedRecord?.date_of_incident
                  ? dayjs(selectedRecord.date_of_incident).format("MMMM D, YYYY")
                  : "",
              },
            ].map((item, idx) => (
              <Box key={idx} sx={{ display: "flex", justifyContent: "space-between", borderBottom: `1px solid ${isDarkMode ? "#1f2937" : "#f3f4f6"}`, pb: 1 }}>
                <Typography sx={{ color: isDarkMode ? "#9ca3af" : "#6b7280", fontWeight: "500" }}>
                  {item.label}
                </Typography>
                <Typography sx={{ fontWeight: "600", color: isDarkMode ? "#f3f4f6" : "#111827" }}>
                  {item.value || ""}
                </Typography>
              </Box>
            ))}

            {/* Comments and Remarks */}
            <Box sx={{ mt: 1 }}>
              <Typography sx={{ color: isDarkMode ? "#9ca3af" : "#6b7280", fontWeight: "500", mb: 0.5 }}>
                Comments:
              </Typography>
              <Box
                sx={{
                  p: 1.5,
                  borderRadius: "8px",
                  border: `1px solid ${isDarkMode ? "#374151" : "#e5e7eb"}`,
                }}
              >
                <Typography
                  sx={{
                    color: isDarkMode ? "#d1d5db" : "#4b5563",
                    fontSize: "0.9rem",
                    lineHeight: "1.5",
                    whiteSpace: "pre-wrap",
                  }}
                >
                  {selectedRecord?.comments
                    ? selectedRecord.comments
                      .replace(/<\/p>|<\/div>|<\/li>|<br\s*\/?>/gi, "\n")
                      .replace(/<[^>]*>/g, "")
                      .trim()
                    : "N/A"}
                </Typography>
              </Box>
            </Box>

            {selectedRecord?.remarks && (
              <Box>
                <Typography sx={{ color: isDarkMode ? "#9ca3af" : "#6b7280", fontWeight: "500", mb: 0.5 }}>
                  Remarks:
                </Typography>
                <Typography
                  sx={{
                    fontSize: "0.9rem",
                    color: isDarkMode ? "#d1d5db" : "#4b5563",
                    whiteSpace: "pre-wrap",
                    p: 1.5,
                    borderRadius: "8px",
                    border: `1px solid ${isDarkMode ? "#374151" : "#e5e7eb"}`,
                  }}
                >
                  {selectedRecord.remarks}
                </Typography>
              </Box>
            )}
          </Box>
        </DialogContent>

      </Dialog>
    </>
  );
};

export default AppraisalFeedback;
